import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import PunchoutLogin from "../../components/Punchout";
import Footer from "../../components/Footer";

const Punchoutlogin = () => {

	return (
		<div>
			<Helmet>
				<title>Punchout Login</title>
			</Helmet>
			{/* <Header /> */}
			<PunchoutLogin />
			<Footer />
		</div>
	);
};

export default Punchoutlogin;